var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCelebrate = function SvgCelebrate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D43",
    d: "M8.5 16c-.202-2.167-.398-3.253-.985-3.905C6.928 11.442 5.95 11.225 4 11c1.95-.225 2.927-.442 3.515-1.095.587-.652.783-1.738.985-3.905.202 2.167.398 3.253.985 3.905.587.653 1.565.87 3.515 1.095-1.95.225-2.927.442-3.515 1.095-.587.652-.783 1.738-.985 3.905",
    opacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D43",
    d: "M61.5 15c-.292-2.817-.575-4.229-1.423-5.077S57.817 8.792 55 8.5c2.817-.292 4.229-.575 5.077-1.423S61.208 4.817 61.5 2c.292 2.817.575 4.229 1.423 5.077S65.183 8.208 68 8.5c-2.817.292-4.229.575-5.077 1.423S61.792 12.183 61.5 15",
    opacity: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F68D1",
    d: "M64.181 60.15c.849 2.383-1.45 4.682-3.832 3.833L30.865 53.481c-2.076-.74-2.673-3.39-1.115-4.947l18.982-18.982c1.558-1.558 4.208-.961 4.947 1.115z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFEBD9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "m45.856 14.387-3.68 3.681a5 5 0 0 0 0 7.071l2.878 2.879"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFD2A8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "m34.63 12.784-2.973 2.973a6 6 0 0 0 0 8.486l8.586 8.586"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF9D43",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "m11.378 29.622 2.267-2.267a7 7 0 0 1 9.9 0L34.63 38.441"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFD2A8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "m16.19 42.45 2.076-2.077a5 5 0 0 1 7.071 0l3.681 3.681"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D43",
    d: "M19.5 68c-.382-3.468-.752-5.204-1.86-6.249C16.53 60.707 14.683 60.36 11 60c3.684-.36 5.53-.708 6.64-1.751 1.109-1.044 1.478-2.782 1.86-6.249.382 3.468.752 5.204 1.86 6.249C22.47 59.293 24.317 59.64 28 60c-3.684.36-5.53.708-6.64 1.751-1.109 1.044-1.478 2.782-1.86 6.249"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 44,
    r: 2,
    fill: "#2F68D1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 30,
    r: 2,
    fill: "#6C9BF1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 4,
    r: 2,
    fill: "#B4CFFF"
  })));
};
export default SvgCelebrate;